export default "__VITE_ASSET__B8HZkUf4__"